import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Play, Heart, Music2, ShieldCheck } from 'lucide-react';
import Strings from '../Strings';
import { IMG } from '../../mock';

export default function Hero() {
  const nav = useNavigate();
  const scrollTo = (id) => document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img src={IMG.heroMic} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(90deg, #0A0806 0%, rgba(10,8,6,0.82) 42%, rgba(10,8,6,0.35) 100%)' }} />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(0deg, #0A0806 2%, transparent 40%)' }} />
      </div>
      <Strings density={8} opacity={0.5} />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 w-full pt-24">
        <div className="max-w-2xl">
          <p className="eyebrow mb-6">Custom theme songs &middot; by P. Frazy &middot; Heart N Soul Records</p>
          <h1 className="font-display text-cream text-6xl md:text-7xl xl:text-8xl leading-[0.92] tracking-tight">
            Your business,<br /><span className="italic text-gold-grad">set to music.</span>
          </h1>
          <p className="mt-8 text-lg text-cream/70 max-w-xl leading-relaxed">
            A song written and produced for your business by songwriter P. Frazy. Tell us who you are, or just paste your website, and hear two or three versions of your song before you pay anything.
          </p>
          <div className="mt-9 flex flex-wrap items-center gap-4">
            <button onClick={() => nav('/start')} className="btn-gold rounded-full px-7 py-3.5 flex items-center gap-2 text-[15px]">
              Get your song <ArrowRight size={18} />
            </button>
            <button onClick={() => scrollTo('#listen')} className="btn-ghost rounded-full px-6 py-3.5 flex items-center gap-2 text-[15px]">
              <Play size={16} className="text-gold" /> Hear the songs
            </button>
          </div>
          <div className="mt-10 flex flex-wrap items-center gap-x-7 gap-y-3 text-sm text-cream/60">
            <span className="flex items-center gap-2"><Heart size={15} className="text-heart" /> Written by a person, not a machine</span>
            <span className="flex items-center gap-2"><Music2 size={15} className="text-gold" /> Hear it before you buy</span>
            <span className="flex items-center gap-2"><ShieldCheck size={15} className="text-gold" /> One price, no subscription</span>
          </div>
        </div>
      </div>
    </section>
  );
}
